var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoUbersuggest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#F16434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.536 22.208C14.432 22.208 16.048 20.432 16.048 17.792V10.8H13.792V17.792C13.792 19.216 12.976 20.112 11.536 20.112C10.096 20.112 9.28 19.216 9.28 17.792V10.8H7.024V17.792C7.024 20.432 8.64 22.208 11.536 22.208ZM21.2861 10.592C19.1421 10.592 17.7661 11.888 17.7661 13.776C17.7661 17.36 22.5981 17.04 22.5981 18.96C22.5981 19.68 22.1021 20.112 21.2701 20.112C20.2621 20.112 19.6381 19.424 19.3341 18.688L17.4301 19.616C17.7501 20.528 18.7421 22.208 21.1421 22.208C23.4781 22.208 24.8861 20.768 24.8861 18.8C24.8861 15.328 20.0221 15.6 20.0221 13.744C20.0221 13.136 20.4701 12.672 21.2381 12.672C22.2141 12.672 22.6301 13.36 22.8701 13.888L24.7421 13.04C24.4701 12.224 23.5421 10.592 21.2861 10.592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUbersuggest);
export default __webpack_public_path__ + "static/media/logo_ubersuggest.6f86c6bf145cccf0a853ac65749d67f8.svg";
export { ForwardRef as ReactComponent };